import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.dokument-bearbeiten-berechtigung-entfernen';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenDokumentBearbeitenBerechtigungEntfernenEffects {

    DokumentBearbeitenBerechtigungEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DOKUMENT_BEARBEITEN_BERECHTIGUNG_ENTFERNEN),
        mergeMap((x: ac.PostDokumentBearbeitenBerechtigungEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDokumentBearbeitenBerechtigungEntfernen(x.dokumentBerechtigungRolleRequest).pipe(
                map((result: any) => {
                    return new ac.PostDokumentBearbeitenBerechtigungEntfernenErfolgreichAction(result, x.dokumentBerechtigungRolleRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDokumentBearbeitenBerechtigungEntfernenFehlerAction(error, x.dokumentBerechtigungRolleRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumentCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumentCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumentCommandService);
        }
        return this.service;
    }
}
